import { createReducer, on } from '@ngrx/store';

export const initialState = null;
import { showAbandonCartInLoader, hideAbandonCartInLoader } from '../_actions/inline-loader.actions';


const _inlineLoaderAbandonCartReducer = createReducer(initialState,
    on(showAbandonCartInLoader, (state) => {
        console.log('Modal Inline Loader - true')
      return true;
    }),
    on(hideAbandonCartInLoader, (state) => {
        console.log('Modal Inline Loader - false')
      return false;
    }),
); 


export function inlineLoaderAbandonCartReducer(state, action) {
    return _inlineLoaderAbandonCartReducer(state, action);
}
